export const FormTextarea = {
  bindings: {
    customClass: '@',
    errors: '<',
    form: '<',
    name: '@',
    minlength: '@',
    onUpdate: '&',
    pattern: '@',
    placeholder: '@',
    required: '@',
    rows: '@',
    value: '<',
  },

  template: `
    <textarea class="form-control {{ $ctrl.customClass }}"
      ng-class="{
        'is-valid': $ctrl.form[$ctrl.name].$touched && $ctrl.form[$ctrl.name].$valid,
        'is-invalid': $ctrl.form[$ctrl.name].$touched && $ctrl.form[$ctrl.name].$invalid,
      }"
      id="{{ $ctrl.name }}"
      name="{{ $ctrl.name }}"
      pattern="{{ $ctrl.pattern }}"
      placeholder="{{ $ctrl.placeholder }}"
      minlength="{{ $ctrl.minlength }}"
      rows="{{ $ctrl.rows }}"
      ng-value="$ctrl.value"
      ng-model="$ctrl.form.data[$ctrl.name]"
      ng-init="$ctrl.form.data[$ctrl.name] = $ctrl.value"
      ng-required="{{ $ctrl.required }}"
      ng-change="$ctrl.onChange()"></textarea>
    <form-errors
      field="$ctrl.form[$ctrl.name]"
      errors="$ctrl.errors"/>`,

  controller() {
    return {
      // For some reason ng-value is not updating ng-model when $ctrl.value
      // resolves. $onChanges is essentially doing this manually.
      $onChanges() {
        const field = this.form[this.name];

        if (this.value && field && !field.$viewValue) {
          field.$setViewValue(this.value);
        }
      },

      // The $setViewValue within $onChanges will fire the ng-change so only
      // call onUpdate when $ctrl.value has actually changed.
      onChange() {
        const key = this.name;
        const value = this.form.data[this.name];
        const field = this.form[this.name];

        if (field.$valid && value !== this.value) {
          this.onUpdate({ key, value });
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/FormElements/FormTextarea.js